import * as React from 'react';

import AvatarXBadge16 from './AvatarXBadge16';

export const avatarXBadge16 = () => <AvatarXBadge16 />;

export default {
    title: 'Icon/Line/AvatarXBadge16',
    component: AvatarXBadge16,
    parameters: {
        notes: "`import AvatarXBadge16 from 'box-ui-elements/es/icon/line/AvatarXBadge16';`",
    },
};
